<template>
  <div>
    <div class="home-box">
      <!-- 轮播 -->
      <div class="slide-box">
        <van-swipe class="my-swipe" :autoplay="4500" indicator-color="#2AD1A4">
          <van-swipe-item
            v-for="(item, i) in state.slidelist"
            :key="i + '-slidelist'"
            @click="goDetailspage(item.gid, item.h5)"
          >
            <div id="swipe-item">
              
              <video
                v-if="item.videourl"
                muted="muted"
                class="myvideo"
                :src="item.videourl"
                :poster="item.slide_pic"
                autoplay="autoplay"
                loop="loop"
                webkit-playsinline="true"
                playsinline="true"
                x-webkit-airplay="allow"
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                x5-video-orientation="portraint"
              >
              </video>
              <img v-else :src="item.slide_pic" />
              <div class="swipe-item-game">
               <div style="display: flex;align-items: center;">
                <h3>{{ item.gamename }}  </h3>
                <span
                  v-if="item.firstpay != 1"
                    style="
                      color: #fff;
                      background-color: #DC417B;
                      margin-left: 8px;
                      border-radius: 3px;
                      font-size: 12px;
                      background: linear-gradient(90deg, #FF6363 0%, #DC417B 100%);
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 46px;
                      height: 21px;
                      text-align: center;
                      line-height: 21px;
                      vertical-align: middle;
                    "
                    >{{ item.firstpay * 10 }}折</span
                  >
               </div>
                <p>
                  <span
                    style="
                      color: #DC417B;
                      margin-left: 3px;
                    "
                    >{{ item.name_sub }}</span
                  >
                  {{ item.abstract }}
                  <span style="color: #ff8f01">{{ item.server }}新服</span>
                </p>
                <div class="welfare-box">
                  <span
                    v-for="(item, index) in item.fuli"
                    :key="index"
                    >{{ item }}</span
                  >
                </div>
                <p id="swipe-item-recommend">{{ item.welfare }}</p>
                <p id="swipe-item-score">
                  {{ item.scoreavg }}
                </p>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, onActivated } from "vue";
import {
  requestSlideUrl,
} from "@/api/gameindex";
import Cookies from "js-cookie";
import { Swiper, Pagination } from "swiper";

import {detect} from '@/utils/device'
import { Toast } from 'vant';


Cookies.set("homeurl", window.location.href, {
  expires: 7,
});
Swiper.use(Pagination);

export default {
  name: "recommendgame",
  components: {
    
  },
  watch: {},

  setup() {
    

   
    const state = reactive({
      overlayshow: true,
      // 轮播图数据
      slidelist: [],
      timer: 10,
    });
  

   

    const getSlidePic = () => {
      requestSlideUrl({}).then((response) => {
        console.log(response.data.data)
        state.slidelist = response.data;
      });
    };

     // 跳转游戏详情
     const goDetailspage = (gid, h5) => {
      //  window.JsBridge.goToGameDetail(gid);
			//   window.webkit.messageHandlers.JsBridge.postMessage("GameDetail://" + gid);
       if (detect() == "android" || detect() == "harmony") {
       window.JsBridge.goToGameDetail(gid);
			}else{
        // Toast('详情')
        var message = "GameDetail://" + gid
         window.webkit.messageHandlers.JsBridge.postMessage(message);
			}
     };

    onMounted(() => {
      getSlidePic();
    });

    //首次打开无数据
    onActivated(() => {
      // console.log("首页onActivated");
      // 本周热门轮播
      let edition = 0;
      // getSlidePic();
    });

    return {
      state,
      goDetailspage
    };
  },
};
</script>

<style scoped="scoped">
.home-box {
  padding-bottom: calc(100px + constant(safe-area-inset-bottom));
  /* 适配安全区域 iOS < 11.2 */
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  /* 适配安全区域 iOS >= 11.2 */
}

/* 轮播样式 */
.my-swipe .van-swipe-item {
  width: 100%;
  height: 923px;
  position: relative;
  transform: translateZ(0);
}

.my-swipe:deep(.van-swipe__indicator) {
  background-color: #000;
}

#swipe-item img {
  height: 783px;
  display: block;
}

.myvideo{
  height: 783px;
  width: 100%;
  object-fit: fill;
}
.video-player {
  height: 783px;
  display: block;
  width: 100%;
  object-fit: fill;
}
.swipe-item-game {
  position: absolute;
  height: 300px;
  top: 635px;
  padding-left: 27px;
  padding-right: 27px;
  will-change: transform
}

.swipe-item-game h3 {
  color: #262626;
  font-size: 44px;
  font-weight: bold;
}

.swipe-item-game p {
  color: #8d8d8f;
  font-size: 26px;
  margin-top: 8px;
}

#swipe-item-score {
  background: url(../../assets/homepage/ic_score_bg.png) no-repeat center bottom;
  background-size: 100% 100%;
  width: 69px;
  height: 81px;
  position: absolute;
  right: 40px;
  top: 48px;
  color: white;
  font-size: 31px;
  text-align: center;
  line-height: 25px;
  padding-top: 10px;
}

#swipe-item-recommend {
  background: url(../../assets/homepage/ic_slide_recommend.png) no-repeat center
    bottom;
  background-size: 100% 100%;
  width: 702px;
  height: 45px;
  margin-top: 18px;
  padding-left: 170px;
  font-size: 24px;
  line-height: 48px;
  white-space: nowrap;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  color: #d89458;
}

.my-swipe .van-swipe-item img {
  width: 100%;
  height: 100%;
}

.custom-indicator {
  text-align: center;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
}

.welfare-box {
  margin-top: 15px;
}

.welfare-box span{
  border-color: #2ad1a4;
  color: #2ad1a4;
  border-radius: 5px;
}
/* 广播样式 */
.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.broadcast-box {
  margin-top: 25px;
  background-color: #e9faf7;
  margin-left: 30px;
  margin-right: 30px;
  height: 75px;
  border-radius: 10px;
}

.broadcast-box .van-swipe-item {
  text-align: left;
}

/* 首页栏目 */


::-webkit-scrollbar {
  display: none;
}
















#booking-bottom {
  position: absolute;
  height: 80px;
  width: 100%;
  bottom: 0px;
  padding: 10px;
  display: flex;
  background: rgba(0, 0, 0, 0.6);
}

#booking-bottom img {
  width: 56px;
  height: 56px;
  top: 12px;
  position: absolute;
  left: 10px;
}

#booking-bottom div h3 {
  position: absolute;
  color: #fff;
  /* width: 140px; */
  margin-left: 60px;
  font-size: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#booking-bottom-p {
  font-size: 20px;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 28px;
  margin-left: 60px;
}








:deep(.van-popup) {
  background-color: transparent;
}

</style>
